import React, { useState } from "react";
import "./nav.style.css";
const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(false);
  const handleShowNavbar = () => {
    setShowNavbar((prevState) => !prevState);
  };
  
  return (
    <div className="nav-container">
      <h2 className="logo">Swagat Vyas</h2>
      <ul className={`nav-items ${showNavbar ? "show-nav" : null}`}>
        <li className="nav-item">
          <a href="#my_story">My Story</a>
        </li>
        <li className="nav-item">
          <a href="#media_coverage">Media Coverage</a>
        </li>
        <li className="nav-item">
          <a href="#articles">Articles</a>
        </li>
        <li className="nav-item">
          <a href="#awards">Awards</a>
        </li>
        <li className="nav-item">
          <a href="#subscribe">Ask Me</a>
        </li>
      </ul>
      <div className="hamburger" onClick={handleShowNavbar}>
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default Navbar;
